import { render, staticRenderFns } from "./DragDropFileUpload.vue?vue&type=template&id=96986b40&"
import script from "./DragDropFileUpload.vue?vue&type=script&lang=js&"
export * from "./DragDropFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DragDropFileUpload.vue?vue&type=style&index=0&id=96986b40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports